import { getRiskLevel } from './risk';

const SEVERITY_RANK = { high: 3, medium: 2, low: 1, unknown: 0 };

function tokenizeTitle(title) {
  return (title || '')
    .toLowerCase()
    .replace(/[^\w\s]/g, ' ')
    .split(/\s+/)
    .filter(w => w.length > 2 && !STOP_WORDS.has(w));
}

const STOP_WORDS = new Set([
  'the', 'and', 'for', 'with', 'from', 'that', 'this', 'are', 'was', 'has', 'have',
  'its', 'will', 'after', 'over', 'into', 'about', 'says', 'said', 'new', 'india',
]);

function wordOverlap(a, b) {
  const wordsA = tokenizeTitle(a);
  const wordsB = tokenizeTitle(b);
  if (wordsA.length === 0 || wordsB.length === 0) return 0;
  const setB = new Set(wordsB);
  const shared = wordsA.filter(w => setB.has(w)).length;
  const union = new Set([...wordsA, ...wordsB]).size;
  return shared / union;
}

export function areSameStory(a, b) {
  if (!a || !b || a.company !== b.company) return false;
  const titleA = (a.title || '').trim();
  const titleB = (b.title || '').trim();
  if (!titleA || !titleB) return false;

  const normA = titleA.toLowerCase().replace(/\s+/g, ' ');
  const normB = titleB.toLowerCase().replace(/\s+/g, ' ');
  if (normA === normB) return true;

  if (normA.length > 20 && (normA.includes(normB) || normB.includes(normA))) return true;

  return wordOverlap(titleA, titleB) >= 0.55;
}

function pickPrimary(records) {
  return [...records].sort((a, b) => {
    const sev = (SEVERITY_RANK[getRiskLevel(b.severity)] || 0) - (SEVERITY_RANK[getRiskLevel(a.severity)] || 0);
    if (sev !== 0) return sev;
    return new Date(b.published_at || 0) - new Date(a.published_at || 0);
  })[0];
}

function recordId(record) {
  return record?.id || record?.url || '';
}

/**
 * Collapse duplicate coverage into one card per story.
 * @returns {{ primary: object, related: object[], sourceCount: number }[]}
 */
export function groupDuplicateStories(records) {
  if (!records?.length) return [];

  const used = new Set();
  const groups = [];

  records.forEach(record => {
    const id = recordId(record);
    if (!id || used.has(id)) return;

    const cluster = [record];
    used.add(id);

    records.forEach(other => {
      const otherId = recordId(other);
      if (!otherId || used.has(otherId)) return;
      if (areSameStory(record, other)) {
        cluster.push(other);
        used.add(otherId);
      }
    });

    const primary = pickPrimary(cluster);
    const related = cluster.filter(r => recordId(r) !== recordId(primary));
    groups.push({
      primary,
      related,
      sourceCount: cluster.length,
    });
  });

  return groups;
}